import { Link } from "react-router-dom";
import radiusLogo from "@/assets/radius-logo.png";

export const PublicFooter = () => {
  return (
    <footer className="border-t bg-muted/50">
      <div className="container py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img src={radiusLogo} alt="Radius" className="h-8 w-8 rounded-lg" />
              <span className="text-lg font-bold">Radius</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Connecting buyers and vendors for seamless B2B procurement.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/for-clients" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  For Buyers
                </Link>
              </li>
              <li>
                <Link to="/for-vendors" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  For Vendors
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/insights" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/how-it-works/clients" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  How It Works - Buyers
                </Link>
              </li>
              <li>
                <Link to="/how-it-works/vendors" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  How It Works - Vendors
                </Link>
              </li>
              <li>
                <Link to="/verification" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Vendor Verification
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Security
                </Link>
              </li>
              <li>
                <Link to="/auth/signup" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Get Started
                </Link>
              </li>
              <li>
                <Link to="/auth/login" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} Radius. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <Link to="/terms" className="hover:text-foreground transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/po-terms" className="hover:text-foreground transition-colors">
                Purchase Order Terms
              </Link>
              <Link to="/privacy#do-not-sell" className="hover:text-foreground transition-colors">
                Do Not Sell or Share My Personal Information
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
